import { jsx as d } from "react/jsx-runtime";
import { useController as f } from "react-hook-form";
import { DatePickerBase as u } from "./index18.mjs";
import { memo as F } from "react";
const k = ({
  control: t,
  name: i,
  defaultValue: m,
  rules: e,
  shouldUnregister: l,
  helperText: n,
  ...a
}) => {
  const {
    field: { onBlur: r, value: c, ...p },
    fieldState: { error: o }
  } = f({
    name: i,
    control: t,
    rules: e,
    defaultValue: m,
    shouldUnregister: l
  }), s = !!e?.required;
  return /* @__PURE__ */ d(
    u,
    {
      ...p,
      value: c ?? null,
      onAccept: r,
      onBlur: r,
      error: !!o,
      helperText: n || o?.message,
      required: s,
      ...a
    }
  );
}, q = F(
  k
);
export {
  q as FormDatePickerField
};
//# sourceMappingURL=index16.mjs.map
